module.exports = __webpack_public_path__ + "static/media/team-connectwork.d408a7ec.png";